// Strips the invisible junk that rides along when an address is pasted from
// a webpage, PDF, or another CRM: zero-width spaces, BOMs, word joiners,
// non-breaking spaces, and directional marks. These characters are literally
// unseeable in the UI but make the address bounce ("Address not found") —
// Henry hit this 2026-08-01 with a pasted Gmail address whose leading
// zero-width space showed up as "Ã¢Â€Â‹" in the bounce notice.
//
// Also handles the already-mangled form: when a UTF-8 zero-width space gets
// read as Latin-1 it becomes the literal characters "â€‹", which is what
// lands in the database if the mojibake was pasted rather than the original.

// U+200B..U+200D zero-width, U+FEFF BOM, U+2060 word joiner,
// U+00A0 non-breaking space, U+200E/U+200F directional marks.
const INVISIBLE = /[​-‍﻿⁠ ‎‏]/g;
// The mojibake spellings of those same characters.
const MOJIBAKE = /(â€‹|â€Œ|â€|Ã¢Â€Â‹|Â )/g;

export function cleanEmail(value) {
  if (value == null) return "";
  return String(value)
    .replace(INVISIBLE, "")
    .replace(MOJIBAKE, "")
    .trim();
}

// True when the value contains hidden characters that would break delivery.
// Used to warn on contacts saved before the cleaning existed.
export function hasHiddenCharacters(value) {
  if (value == null) return false;
  const s = String(value);
  return INVISIBLE.test(s) || MOJIBAKE.test(s) || s !== s.trim();
}
